export const PROFILE_SECTIONS = [
  { id: 'overview', label: 'Overview' },
  { id: 'risk', label: 'Risk' },
  { id: 'timeline', label: 'Timeline' },
  { id: 'screening', label: 'Screening' },
  { id: 'identity', label: 'Identity' },
  { id: 'declarations', label: 'Declarations' },
]

export const LIST_PREVIEW_LIMIT = 5

export function profileSectionAnchorId(sectionId) {
  return `profile-section-${sectionId}`
}

export const TIMELINE_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'kyc', label: 'KYC' },
  { id: 'screening', label: 'Screening' },
  { id: 'investigations', label: 'Investigations' },
  { id: 'uar', label: 'UAR' },
  { id: 'alerts', label: 'Alerts' },
]
